import { Link } from "react-scroll";
import "./Navbar.css";
import { MdMenu } from "react-icons/md";
import { BsXLg } from "react-icons/bs";
import { useState } from "react";
const Navbar = () => {
  const [ismanu, setIsmanu] = useState(false);
  return (
    <>
      <nav
        id="portfolio-navbar"
        className="mx-auto p-0 bg-green text-dark "
        style={{ position: "sticky", top: "0", zIndex: "500" }}
      >
        <ul className="d-flex  position-relative m-0">
          <Link to="hero" spy={true} offset={-150} duration={0} smooth={true}>
            {" "}
            <li className="h5 d-flex" data-aos="fade-down ">
              <img
                className="my-auto pt-2"
                width={40}
                src="/images/logos-removebg-preview.2878fb6bf5cfd441c9bf (1).png"
                alt=""
              />
            </li>
          </Link>
          {ismanu ? (
            <li className={`text-end ms-auto pe-4 my-auto toggle-cons `}>
              <BsXLg size={35} onClick={() => setIsmanu(!ismanu)} />
            </li>
          ) : (
            <li className="text-end ms-auto pe-4 my-auto toggle-cons ">
              <MdMenu size={35} onClick={() => setIsmanu(!ismanu)} />
            </li>
          )}
          <ul
            className={`ms-auto gap-4 port-navbar ${
              ismanu ? "navbar-response" : ""
            } `}
          >
            <Link
              to="hero"
              activeClass="active"
              spy={true}
              offset={-150}
              duration={0}
              smooth={true}
            >
              <li className="p-2 fs-4" data-aos="fade-down">
                Home
              </li>
            </Link>
            <Link
              activeClass="active"
              to="service"
              spy={true}
              offset={-150}
              duration={0}
              smooth={true}
            >
              <li className="p-2 fs-4" data-aos="fade-down">
                Service
              </li>
            </Link>
            <Link
              activeClass="active"
              to="skills"
              spy={true}
              offset={-150}
              duration={0}
              smooth={true}
            >
              <li className="p-2 fs-4" data-aos="fade-down">
                Skills
              </li>
            </Link>

            <Link
              activeClass="active"
              to="team"
              spy={true}
              offset={-150}
              duration={0}
              smooth={true}
            >
              <li className="p-2 fs-4" data-aos="fade-down">
                Team
              </li>
            </Link>

            <Link
              activeClass="active"
              to="project"
              spy={true}
              offset={-150}
              duration={0}
              smooth={true}
            >
              <li className="p-2 fs-4" data-aos="fade-down">
                Projects
              </li>
            </Link>
            <Link
              activeClass="active"
              to="about"
              spy={true}
              offset={-150}
              duration={0}
              smooth={true}
            >
              <li className="p-2 fs-4" data-aos="fade-down">
                About
              </li>
            </Link>
          </ul>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
